import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0fdc8fde"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "seaction-header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
export default /*#__PURE__*/_defineComponent({
  __name: 'course-seaction-header',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createTextVNode(_toDisplayString(__props.title) + " ", 1), _hoisted_2, _createTextVNode(" " + _toDisplayString(__props.subTitle), 1)]);
    };
  }
});